import getHashedCustomerId from "./getHashedCustomerId";
import getCookieConsent from "./getCookieConsent";
import { AD_SIZE_MAPPINGS } from "./adSizeMappingConfig";

const initiateGoogleAds = async (
  {
    adId,
    fetchMarginPercent,
    forceSafeIframe,
    adUnitPath,
    mobileMarginScaling,
    renderMarginPercent
  },
  handleGoogleLoad
) => {
  if (!window.asos?.webContext) return;

  const {
    desktopSize1,
    desktopSize2,
    tabletSize1,
    tabletSize2,
    mobileSize1,
    mobileSize2,
    mobileSize3
  } = AD_SIZE_MAPPINGS;

  const webContext = window.asos.webContext;

  window.googletag = window.googletag || { cmd: [] };

  const googletag = window.googletag;

  const [cookieConsent, hashedCustomerId] = await Promise.all([
    getCookieConsent(),
    getHashedCustomerId()
  ]);

  googletag.cmd.push(() => {
    const mapping = googletag
      .sizeMapping()
      .addSize(desktopSize1, [desktopSize2])
      .addSize(tabletSize1, tabletSize2)
      .addSize(mobileSize1, [mobileSize2, mobileSize3])
      .build();

    googletag
      .defineSlot(adUnitPath, "fluid", adId)
      .setTargeting("browseCountry", webContext.getBrowseCountry())
      .setTargeting("browseLanguage", webContext.getBrowseLanguage())
      .setTargeting("browseCurrency", webContext.getBrowseCurrency())
      .setTargeting("browseSizeSchema", webContext.getBrowseSizeSchema())
      .defineSizeMapping(mapping)
      .addService(googletag.pubads());

    if (hashedCustomerId) {
      googletag.pubads().setPublisherProvidedId(hashedCustomerId);
    }

    googletag.pubads().enableLazyLoad({
      fetchMarginPercent,
      renderMarginPercent,
      mobileScaling: mobileMarginScaling
    });

    googletag.pubads().addEventListener("slotOnload", () => {
      handleGoogleLoad();
    });

    googletag.pubads().setForceSafeFrame(forceSafeIframe);
    googletag.pubads().collapseEmptyDivs();
    googletag.pubads().setRequestNonPersonalizedAds(cookieConsent);

    googletag.enableServices();
    googletag.display(adId);
  });
};

export default initiateGoogleAds;
